module.exports = __webpack_public_path__ + "img/20110201_01.0777e41e.jpg";